/* global gsap */

// dataset attributes are strings
const isStrFloat = (str) => {
  return str.indexOf('.') === 1;
};

// already converted by parseData,
// so safe to assume a number
const isNumFloat = (num) => {
  return num % 1 !== 0;
};

// parse data attribute as float or int
const parseData = (val) => {
  if (isStrFloat(val)) {
    return parseFloat(val);
  }

  return parseInt(val);
};

// to calculate whole numbers from progress: Math.floor(progress * (0 - 100) + 100)
const animateValue = (element, duration) => {
  let startTimestamp = null;
  let float = false;

  const min = parseData(element.dataset.min);
  const max = parseData(element.dataset.max);
  const final = parseData(element.dataset.final);

  if (isNumFloat(min) || isNumFloat(max) || isNumFloat(final)) {
    float = true;
  } else {
    float = false;
  }

  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp;

    const progress = Math.min((timestamp - startTimestamp) / duration, 1);

    if (float) {
      element.innerHTML = (Math.random() * (max - min) + min).toFixed(1);
    } else {
      element.innerHTML = parseInt(Math.random() * (max - min) + min);
    }

    if (progress < 1) {
      window.requestAnimationFrame(step);
    } else {
      element.innerHTML = final;
    }
  };

  window.requestAnimationFrame(step);
};

const init = () => {
  const elements = document.querySelectorAll('[data-ref="animated-number"]');

  if (elements && elements.length) {
    elements.forEach((element) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: element,
          once: true,
          start: 'bottom bottom',
          onEnter: () => {
            animateValue(element, 500);
          },
        },
      });

      const shapes = document.querySelectorAll('[data-ref="number-shape"]');

      tl.to(shapes, {
        rotation: 360,
        repeat: -1,
        duration: 20,
        ease: 'none',
      });
    });
  }
};

init();
